import React from 'react';

const logo = "https://i.wlycdn.com/articles/Wealthy-logo-calculators.svg";

function ReportHeader({ data, formatDate, advisorName, clientName }) {
  console.log(data, clientName, advisorName, formatDate, "from header");
    return (
        <header
            className="report-header p-8 md:p-12 rounded-none md:rounded-lg mb-8 md:mb-12 relative"
            style={{
                backgroundColor: 'rgba(255, 255, 255, 0.4)'
            }}
        >
            {/* Top section with logo and advisor info */}
            <div className="flex justify-between items-center mb-8">
                <div className="flex items-center gap-3 w-full">
                    {/* Wealthy logo section */}
                    <div className="flex items-center gap-2 w-full justify-center">
                        <img src={logo} alt="wealthy.in" className="w-20 h-20" />
                        <span className="text-lg text-gray-600">×</span>
                        {/* <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center">
                            <span className="text-sm font-semibold text-purple-700">
                                {advisorName ? advisorName[0] : 'S'}
                            </span>
                        </div> */}


                        <span className="text-sm text-gray-600">
                            {advisorName || 'Somit Srivastava'}
                        </span>
                    </div>
                </div>
            </div>

            {/* Center content */}
            <div className="text-center">
                {/* Main heading */}
                <h1 className="text-4xl md:text-6xl font-normal text-gray-800 mb-4">
                    Life का Plan
                </h1>

                {/* Subtitle */}
                <p className="text-xl md:text-2xl text-gray-600 mb-8">
                    Your Financial health Report
                </p>

                {/* Divider line */}
                <div className="w-24 h-px bg-gray-400 mx-auto mb-8"></div>

                {/* Client name */}
                <h2 className="text-3xl md:text-4xl font-normal text-gray-800 capitalize">
                    {`${clientName} & Family`}
                </h2>
            </div>

            {/* Decorative elements */}
            <div className="absolute top-4 left-1 w-12 h-12 bg-green-200 opacity-30 rounded transform rotate-12"></div>
            <div className="absolute bottom-4 right-4 w-16 h-16 bg-pink-200 opacity-30 rounded transform -rotate-12"></div>
        </header>
    );
}

export default ReportHeader;







// import React from 'react';

// const logo = "https://i.wlycdn.com/articles/Wealthy-logo-calculators.svg";

// function ReportHeader({ data, formatDate, advisorName, clientName }) {
//   console.log(data, clientName, advisorName, formatDate, "from header");
//     return (
//         <header className="report-header p-5 md:p-6 rounded-none md:rounded-lg shadow-md mb-5 md:mb-8">
//             <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-2">
//                 <div className="flex items-center gap-3">
//                     {/* Logo or Initials */}
//                     {/* <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center text-2xl font-bold text-purple-700">
//                         {clientName ? clientName[0] : 'C'}
//                     </div> */}
//                     <div>
//                         {/* <h1 className="text-2xl md:text-3xl font-bold text-purple-700 leading-tight">wealthy.in</h1> */}
//                         <img src={logo} alt="wealthy.in" className="w-20 h-20" />
//                         <div className="text-xs md:text-sm text-gray-600 mt-1">Report Generated: {formatDate(data.generated_date)}</div>
//                     </div>
//                 </div>
//                 <div className="text-right">
//                     <div className="text-lg font-semibold text-gray-800">{clientName}</div>
//                     <div className="text-xs text-gray-500 mb-1">Advisor: {advisorName}</div>
//                 </div>
//             </div>
//             <div className="text-left sm:text-center mt-2">
//                 <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
//                     Financial Health Report
//                 </h2>
//                 <p className="text-sm md:text-base text-gray-600 mt-2">
//                     Prepared for {data.client_id || clientName}
//                 </p>
//             </div>
//         </header>
//     );
// }

// export default ReportHeader;
